import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/button";

export const ThemeSwitcher = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const isDark = getThemeFromLocalStorage();
    setIsDark(isDark);
    if (isDark) toggleDarkTheme(true);
  }, []);

  const handleThemeChange = () => {
    setIsDark((prev) => {
      toggleDarkTheme(!prev);
      return !prev;
    });
  };

  const toggleDarkTheme = (isDark: boolean) => {
    if (isDark) {
      document.documentElement.classList.add("dark");
      setThemeToLocalStorage(true);
    } else {
      document.documentElement.classList.remove("dark");
      setThemeToLocalStorage(false);
    }
  };

  return (
    <div className="flex items-center justify-end gap-2">
      <Button size="sm" onClick={handleThemeChange} variant="ghost">
        {isDark ? <Sun /> : <Moon />}
      </Button>
    </div>
  );
};

const getThemeFromLocalStorage = () => {
  return localStorage.getItem("theme") === "dark";
};
const setThemeToLocalStorage = (isDark: boolean) => {
  localStorage.setItem("theme", isDark ? "dark" : "light");
};
